import { Stack, Text } from "@mantine/core";
import type { FC, ReactNode } from "react";

interface SimpleBreadcrumbsProps {
  current: string;
  parent?: ReactNode | string;
  description?: ReactNode | string;
}

export const SimpleBreadcrumbs: FC<SimpleBreadcrumbsProps> = ({ current, parent, description }) => {
  return (
    <Stack gap="xs">
      {parent && (
        <Text size="1rem" fw="bold">
          {parent}
        </Text>
      )}
      {current && (
        <Text size="2rem" fw="bold">
          {current}
        </Text>
      )}
      {description && (
        <Text>
          {description}
        </Text>
      )}
    </Stack>
  );
};
